module.exports = "/_next/static/images/43eef5fa8566d8c00a4aa3659d8e9895-man-with-cellphone-md@3x.jpg.webp";